import React from 'react'
import CardItem from './CardItem'
import  './Cards.css'

function ContactCards(){
    return(
        <div className='contact-cards' >
            <div className="cards__container'">
                <div className="cards__wrapper">
                    <ul className="cards__items">
                    <CardItem 
                    src="images/img-30-transformed.jpeg"
                    text="My Email"
                    label='Personal'
                    path='https://mail.google.com/mail/?view=cm&fs=1&to=kamsibenagu22@gmail.com&su=&body='
                    />
                    <CardItem 
                    src="images/img-31.jpg"
                    text="Github"
                    label='Personal'
                    path='https://github.com/kamC0des'
                    />
                    <CardItem 
                    src="images/img-33.jpg"
                    text="LinkedIn"
                    label='Personal'
                    path='https://linkedin.com/in/kamsi-ben-agu'
                    />
                    </ul>
                </div>
            </div>
        </div>
    );
}
export default ContactCards